import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Row, Col, Card, Alert, Button } from 'react-bootstrap';
import { ROUTES } from '../constants/routes';

const ErrorPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const errorType = searchParams.get('type') || 'unknown';

  const getErrorContent = () => {
    switch (errorType) {
      case 'session':
        return {
          title: 'Session Error',
          message: (
            <>
              <p>The Assist application has detected multiple sessions associated with your username.</p>
              <p>For security purposes the application does not allow a user to have more than one active session at a time.</p>
              <p>Do you have the energy assistance application opened in a separate browser window? Or, you may try closing your browser and logging back in.</p>
            </>
          )
        };
      case 'rate-limit':
        return {
          title: 'Too Many Requests',
          message: (
            <>
              <p>You have exceeded the maximum number of search requests allowed.</p>
              <p>Please wait a moment before trying again.</p>
            </>
          )
        };
      case 'server':
        return {
          title: 'Server Error',
          message: (
            <>
              <p>An unexpected error occurred on the server.</p>
              <p>Please try again later. If the problem persists, contact support.</p>
            </>
          )
        };
      default:
        return {
          title: 'Error',
          message: <p>An unexpected error occurred. Please try again.</p>
        };
    }
  };

  const { title, message } = getErrorContent();

  return (
    <div className="error-page">
      <Row className="justify-content-center">
          <Col md={8}>
            <Card className="shadow">
              <Card.Header className="bg-danger">
                <h4 className="mb-0">{title}</h4>
              </Card.Header>
              <Card.Body>
                <Alert variant="danger">
                  {message}
                </Alert>
                <Button
                  variant="primary"
                  onClick={() => navigate(ROUTES.LOGIN)}
                >
                  Return to Login
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
    </div>
  );
};

export default ErrorPage;
